import { required } from "./field-rules";
import { password } from "./field-icons";

export default [
  {
    name: "branch",
    attrs: {
      type: "select",
      label: "Организация",
      required: true, // переопределяется
      items: [], // переопределяется
    },
    rules: [required]
  },
  {
    name: "username",
    attrs: {
      type: "text",
      label: "Логин",
      required: true
    },
    rules: [required]
  },
  {
    name: "password",
    attrs: {
      type: "password",
      label: "Пароль",
      required: true,
      appendIcons: password
    },
    rules: [required]
  }
];
